import ServicesAssigned from './AssignedServices'
export function AssignedModulesContainer() {
	/**
	  JSX Section
	 * @returns AssignedModulesConatiner
	 */
	return (
		<div className="px-4 flex flex-col">
			<ServicesAssigned />
		</div>
	)
}
